import React, { useEffect, useState, lazy, createElement, Component } from 'react';
import { CheckCircle2, XCircle, Clock, Star, FileText, Zap, ShieldCheck, Users, BookOpen, Gift, ChevronDown, AlertCircle, ArrowRight, MessageSquare, Calendar, Layers, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// --- Sub-components ---
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 27,
    seconds: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex gap-2 font-mono text-xl md:text-2xl font-bold text-white" data-id="element-1">
      <div className="bg-[#C62828] px-2 py-1 rounded border border-white/20" data-id="element-2">
        {String(timeLeft.hours).padStart(2, '0')}h
      </div>
      <span className="text-white" data-id="element-3">:</span>
      <div className="bg-[#C62828] px-2 py-1 rounded border border-white/20" data-id="element-4">
        {String(timeLeft.minutes).padStart(2, '0')}m
      </div>
      <span className="text-white" data-id="element-5">:</span>
      <div className="bg-[#C62828] px-2 py-1 rounded border border-white/20" data-id="element-6">
        {String(timeLeft.seconds).padStart(2, '0')}s
      </div>
    </div>;
};
const FloatingNotification = () => {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const notifications = [{
    n: 'Laura G.',
    l: 'Buenos Aires',
    t: 'hace 6 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Marcos F.',
    l: 'Córdoba',
    t: 'hace 2 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Valeria R.',
    l: 'Rosario',
    t: 'hace 15 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Daniel M.',
    l: 'Mendoza',
    t: 'hace 8 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Roberto P.',
    l: 'La Plata',
    t: 'hace 12 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Analía S.',
    l: 'Santa Fe',
    t: 'hace 4 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Claudia M.',
    l: 'Salta',
    t: 'hace 19 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Sergio B.',
    l: 'Tucumán',
    t: 'hace 3 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Patricia L.',
    l: 'Mar del Plata',
    t: 'hace 22 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Ricardo T.',
    l: 'Corrientes',
    t: 'hace 7 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Mónica V.',
    l: 'Bahía Blanca',
    t: 'hace 11 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Javier H.',
    l: 'Jujuy',
    t: 'hace 5 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Silvia J.',
    l: 'Posadas',
    t: 'hace 14 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Gustavo D.',
    l: 'Paraná',
    t: 'hace 9 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Beatriz K.',
    l: 'Neuquén',
    t: 'hace 17 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Alejandro N.',
    l: 'Formosa',
    t: 'hace 2 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Liliana O.',
    l: 'San Luis',
    t: 'hace 25 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Fernando Q.',
    l: 'San Juan',
    t: 'hace 6 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Graciela W.',
    l: 'Catamarca',
    t: 'hace 13 minutos',
    p: 'el Pack Completo 🚨'
  }, {
    n: 'Marcelo Z.',
    l: 'La Rioja',
    t: 'hace 10 minutos',
    p: 'el Pack Completo 🚨'
  }];
  useEffect(() => {
    const showNotification = () => {
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    // Initial delay before first notification
    const initialTimeout = setTimeout(showNotification, 3000);
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      showNotification();
    }, 10000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [notifications.length]);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-7">
      {visible && <motion.div initial={{
      opacity: 0,
      y: -50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} className="fixed top-6 left-6 z-50 bg-white shadow-2xl rounded-lg p-4 border border-slate-100 flex items-center gap-4 max-w-sm" data-id="element-8">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-[#10A37F]" data-id="element-9">
            <Check size={20} data-id="element-10" />
          </div>
          <div data-id="element-11">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-12">
              Compra verificada
            </p>
            <p className="text-sm text-slate-800" data-id="element-13">
              <span className="font-bold" data-id="element-14">{current.n}</span> de {current.l}
              <br data-id="element-15" />
              compró {current.p}
            </p>
            <p className="text-xs text-slate-400 mt-1" data-id="element-16">{current.t}</p>
          </div>
          <button onClick={() => setVisible(false)} className="text-slate-300 hover:text-slate-500" data-id="element-17">
            <XCircle size={16} data-id="element-18" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};
const SectionTitle = ({
  children,
  subtitle,
  light = false
}: {
  children: React.ReactNode;
  subtitle?: string;
  light?: boolean;
}) => <div className="text-center mb-3 md:mb-6" data-id="element-19">
    <h2 className={`${`text-3xl md:text-5xl font-bold mb-1 md:mb-2 ${light ? 'text-white' : 'text-slate-900'}`} text-[24px]`} data-id="element-20">
      {children}
    </h2>
    {subtitle && <p className={`${`text-base md:text-lg ${light ? 'text-slate-200' : 'text-slate-600'} max-w-2xl mx-auto font-sans px-4 leading-snug`} text-[12px]`} data-id="element-21">
        {subtitle}
      </p>}
  </div>;
const CTAButton = ({
  children,
  secondary = false,
  className = '',
  href = '',
  onClick
}: {
  children: React.ReactNode;
  secondary?: boolean;
  className?: string;
  href?: string;
  onClick?: () => void;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (window.fbq) {
      if (href.includes('cart')) {
        const isTier2 = href.includes('44367122530397');
        window.fbq('track', 'InitiateCheckout', {
          content_name: isTier2 ? 'Colección + Organizador' : 'Colección Completa',
          value: isTier2 ? 24990 : 19990,
          currency: 'ARS'
        });
      } else if (href === '#pricing') {
        window.fbq('track', 'ViewContent', {
          content_name: 'Pricing Section'
        });
      }
    }
    if (onClick) onClick();
  };
  const content = <motion.button animate={{
    scale: [1, 1.05, 1]
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`${`${`
        w-full md:w-auto px-10 py-5 rounded-full font-bold text-lg transition-all transform shadow-xl
        ${secondary ? 'bg-white text-[#1A237E] border-2 border-slate-200 hover:bg-slate-50' : 'bg-[#16A34A] text-white hover:bg-[#15803D]'}
        ${className}
      `} text-[18px] pt-[15px] pb-[15px] pl-[0px] pr-[0px]`} text-[16px] pt-[10px] pb-[10px]`} onClick={handleClick} data-id="element-22">
      {children}
    </motion.button>;
  if (href) {
    const isInternal = href.startsWith('#');
    return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className="w-full md:w-auto block" onClick={e => {
      handleClick(e);
      if (isInternal) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }} data-id="element-23">
        {content}
      </a>;
  }
  return content;
};
// Payment trust block: shown right BEFORE the CTA button
const PaymentTrustBlock = ({
  dark = false
}: {
  dark?: boolean;
}) => <div className="w-full max-w-md mx-auto mb-4 text-center" data-id="element-24">
    <p className={`text-xs md:text-sm font-medium mb-2 ${dark ? 'text-white/80' : 'text-slate-600'}`} data-id="element-25">
      Pagarás de forma 100% segura mediante:
    </p>
    <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 flex-wrap" data-id="element-26">
      <div className="bg-white rounded-md px-2.5 py-1.5 shadow-sm border border-slate-200 flex items-center" data-id="element-27">
        <img src="https://cdn.simpleicons.org/mercadopago/00B1EA" alt="Mercado Pago" className="h-5 md:h-6 w-auto" data-id="element-28" />
        <span className="ml-1.5 text-[10px] md:text-xs font-bold text-[#00B1EA]" data-id="element-29">
          Mercado Pago
        </span>
      </div>
      <div className="bg-white rounded-md px-2.5 py-1.5 shadow-sm border border-slate-200" data-id="element-30">
        <img src="https://cdn.simpleicons.org/visa/1A1F71" alt="Visa" className="h-4 md:h-5 w-auto" data-id="element-31" />
      </div>
      <div className="bg-white rounded-md px-2.5 py-1.5 shadow-sm border border-slate-200" data-id="element-32">
        <img src="https://cdn.simpleicons.org/mastercard" alt="Mastercard" className="h-4 md:h-5 w-auto" data-id="element-33" />
      </div>
      <div className="bg-white rounded-md px-2.5 py-1.5 shadow-sm border border-slate-200 text-[9px] md:text-[10px] font-bold text-[#E20613] tracking-tight" data-id="element-34">
        RapiPago<span className="text-slate-400 mx-0.5" data-id="element-35">·</span>
        <span className="text-[#0EA5E9]" data-id="element-36">PagoFácil</span>
      </div>
    </div>
    <div className="bg-[#F0FDF4] border border-[#BBF7D0] rounded-lg px-3 py-2 text-[#166534] font-medium leading-snug" style={{
    fontSize: '13px'
  }} data-id="element-37">
      📦 <strong data-id="element-38">ENTREGA DIGITAL INSTANTÁNEA:</strong> Sin costos de envío.
      Recibís el acceso en tu email al instante.
    </div>
  </div>;
// Trust badges shown right AFTER the CTA button
const PurchaseSupportBadges = ({
  dark = false
}: {
  dark?: boolean;
}) => <div className="w-full max-w-md mx-auto mt-3" data-id="element-39">
    <p className={`text-[11px] md:text-xs italic mb-3 text-center ${dark ? 'text-white/70' : 'text-slate-500'}`} data-id="element-40">
      Serás redirigido a la pasarela segura de Mercado Pago.
    </p>
    <div className="grid grid-cols-3 gap-2 text-center" data-id="element-41">
      <div className="flex flex-col items-center gap-1" data-id="element-42">
        <span className="text-lg md:text-xl" data-id="element-43">🛡️</span>
        <p className={`text-[10px] md:text-[11px] leading-tight font-medium ${dark ? 'text-white/80' : 'text-slate-600'}`} data-id="element-44">
          Compra Protegida
          <br data-id="element-45" />
          por Mercado Pago
        </p>
      </div>
      <div className="flex flex-col items-center gap-1" data-id="element-46">
        <span className="text-lg md:text-xl" data-id="element-47">⚡</span>
        <p className={`text-[10px] md:text-[11px] leading-tight font-medium ${dark ? 'text-white/80' : 'text-slate-600'}`} data-id="element-48">
          Acceso Inmediato
          <br data-id="element-49" />
          (Formato PDF)
        </p>
      </div>
      <div className="flex flex-col items-center gap-1" data-id="element-50">
        <span className="text-lg md:text-xl" data-id="element-51">🏅</span>
        <p className={`text-[10px] md:text-[11px] leading-tight font-medium ${dark ? 'text-white/80' : 'text-slate-600'}`} data-id="element-52">
          7 Días de Garantía
          <br data-id="element-53" />
          de Satisfacción
        </p>
      </div>
    </div>
  </div>;
// Floating WhatsApp button (fixed bottom-right)
const FloatingWhatsApp = () => {
  const phone = '542966244076';
  const message = 'Hola! Vengo de la página código emergencia escolar y necesito ayuda con mi pago. ¿Me podrías asesorar?';
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" aria-label="Hablar por WhatsApp" initial={{
    opacity: 0,
    scale: 0
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    delay: 1.2,
    type: 'spring',
    stiffness: 200,
    damping: 15
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] hover:bg-[#128C7E] rounded-full flex items-center justify-center shadow-[0_8px_24px_rgba(37,211,102,0.5)] ring-4 ring-white/40" data-id="element-54">
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" data-id="element-55"></span>
      <svg viewBox="0 0 24 24" className="relative w-7 h-7 md:w-8 md:h-8 text-white" fill="currentColor" aria-hidden="true" data-id="element-56">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" data-id="element-57" />
      </svg>
    </motion.a>;
};
// --- Main Page ---
export function LandingPage() {
  const [showUpsellDetails, setShowUpsellDetails] = useState(false);
  useEffect(() => {
    if (!window.fbq) {
      const f = window as any;
      const b = document;
      const e = 'script';
      const v = 'https://connect.facebook.net/en_US/fbevents.js';
      let n: any, t: any, s: any;
      f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      n = f.fbq;
      if (!f._fbq) f._fbq = n;
      f.fbq.push = f.fbq;
      f.fbq.loaded = !0;
      f.fbq.version = '2.0';
      f.fbq.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }
    if (window.fbq) {
      window.fbq('init', '1313291250496067');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-58">
      <FloatingNotification data-id="element-59" />

      {/* Meta Pixel Noscript */}
      <noscript data-id="element-60">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1313291250496067&ev=PageView&noscript=1" data-id="element-61" />
      </noscript>

      {/* Hero Section */}
      <header className="relative bg-[#1A237E] min-h-[100svh] flex flex-col text-white overflow-hidden" data-id="element-62">
        <div className="absolute top-0 left-0 w-full h-1 flex" data-id="element-63">
          <div className="flex-1 bg-white/20" data-id="element-64"></div>
          <div className="flex-1 bg-white/40" data-id="element-65"></div>
          <div className="flex-1 bg-white/20" data-id="element-66"></div>
        </div>

        <div className="container mx-auto px-4 flex-grow flex flex-col justify-center pt-4 pb-2 md:pt-12 md:pb-4 relative z-10" data-id="element-67">
          <div className="max-w-4xl mx-auto text-center flex flex-col h-full" data-id="element-68">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="inline-flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full text-white text-[10px] md:text-sm font-bold mb-2 md:mb-4 backdrop-blur-sm self-center" data-id="element-69">
              🚨 CÓDIGO EMERGENCIA ESCOLAR™
            </motion.div>

            <h1 className="md:text-7xl font-bold mb-2 md:mb-4 text-white text-[24px] leading-tight" data-id="element-70">
              Un protocolo claro para saber qué decir y cómo actuar ante una
              amenaza escolar.
            </h1>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.8
          }} className="relative max-w-[423px] md:max-w-[1178px] mx-auto mb-3 md:mb-8 group" data-id="element-71">
              <div className="absolute inset-0 bg-[#E65100] blur-3xl opacity-20 group-hover:opacity-40 transition-opacity duration-700" data-id="element-72"></div>
              <img src="https://cdn.magicpatterns.com/uploads/rzfibkpJEqjQkydDx9baQw/codigo-emergencia-escolar-optimized.webp" alt="Código Emergencia Escolar Mockup" className="relative z-10 w-full h-auto rounded-xl shadow-2xl" fetchPriority="high" data-id="element-73" />
            </motion.div>

            <p className="text-lg md:text-2xl text-white/80 mb-3 md:mb-6 max-w-2xl mx-auto leading-snug px-4" data-id="element-74">
              Hay una manera clara de actuar ante una amenaza en la escuela.{' '}
              <br data-id="element-75" />
              <span className="font-bold text-white" data-id="element-76">Y podés empezar hoy.</span>
            </p>

            <div className="flex flex-col items-center gap-2 md:gap-4 mb-3 md:mb-8" data-id="element-77">
              <CTAButton href="#pricing" className="uppercase tracking-wide px-8 py-4 md:px-12 md:py-5 text-sm md:text-lg" data-id="element-78">
                → QUIERO EL PROTOCOLO.
              </CTAButton>

              <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-[#1A237E] font-medium text-[10px] md:text-sm" data-id="element-79">
                <div className="flex items-center gap-1 bg-white/90 px-3 py-1 rounded-full" data-id="element-80">
                  <FileText size={14} data-id="element-81" /> 100% PDF
                </div>
                <div className="flex items-center gap-1 bg-white/90 px-3 py-1 rounded-full" data-id="element-82">
                  <Zap size={14} data-id="element-83" /> Acceso en 5 min
                </div>
                <div className="flex items-center gap-1 bg-white/90 px-3 py-1 rounded-full" data-id="element-84">
                  <ShieldCheck size={14} data-id="element-85" /> Garantía 7 días
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Stats Section */}
      <section className="pt-2 pb-4 md:pt-4 md:pb-10 bg-[#1A237E] border-b border-white/10" data-id="element-86">
        <div className="container mx-auto px-4 mt-[-16px] mb-[-16px]" data-id="element-87">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto text-center" data-id="element-88">
            {[{
            label: 'docentes y familias',
            value: '+500'
          }, {
            label: 'módulos y bonos',
            value: '7'
          }, {
            label: 'páginas listas',
            value: '270+'
          }, {
            label: 'calificación',
            value: '4.9/5',
            stars: true
          }].map((stat, i) => <div key={i} data-id="element-89">
                <p className="text-3xl md:text-4xl font-bold text-[#E65100] mb-1" data-id="element-90">
                  {stat.value}
                </p>
                {stat.stars && <div className="flex justify-center text-yellow-500 mb-1" data-id="element-91">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-92" />)}
                  </div>}
                <p className="text-[10px] md:text-xs uppercase tracking-widest text-white font-bold" data-id="element-93">
                  {stat.label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonials Marquee */}
      <section className="py-4 md:py-16 bg-white" data-id="element-94">
        <div className="container mx-auto px-4 mb-4 md:mb-8" data-id="element-95">
          <SectionTitle subtitle="Docentes y directivos que ya transformaron su manera de actuar." data-id="element-96">
            <span className="text-[#1A237E]" data-id="element-97">❤️ TESTIMONIOS</span>
          </SectionTitle>
        </div>

        <div className="container mx-auto px-4" data-id="element-98">
          <div className="flex flex-col gap-3 md:gap-4 max-w-3xl mx-auto" data-id="element-99">
            {[{
            n: 'Laura G.',
            l: 'Buenos Aires · Docente de secundaria',
            q: 'Llegué a la reunión de padres sin saber qué decir. Con este material tuve un taller completo listo para usar en 24 horas.',
            i: 'LG'
          }, {
            n: 'Marcos F.',
            l: 'Córdoba · Director de escuela privada',
            q: 'El Módulo 2 me salvó cuando recibimos una amenaza anónima en el grupo de WhatsApp. Supe exactamente qué hacer en los primeros 60 minutos.',
            i: 'MF'
          }, {
            n: 'Valeria R.',
            l: 'Rosario · Orientadora escolar',
            q: 'Por fin un material que habla en argentino, con leyes argentinas y situaciones reales de nuestras escuelas.',
            i: 'VR'
          }, {
            n: 'Daniela M.',
            l: 'Mendoza · Profesora de ESI',
            q: 'El Módulo 3 lo usé la semana siguiente de comprarlo. Los alumnos estuvieron enganchados toda la hora.',
            i: 'DM'
          }, {
            n: 'Roberto P.',
            l: 'Buenos Aires · Director de primaria',
            q: 'El Módulo 1 me dio la seguridad legal que necesitaba para hablar con los padres sin tener miedo de decir algo mal.',
            i: 'RP'
          }].map((test, i) => <div key={i} className="w-full bg-[#F5F5F5] p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col justify-between" data-id="element-100">
                <div data-id="element-101">
                  <div className="flex gap-1 mb-4 text-yellow-500" data-id="element-102">
                    {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-103" />)}
                  </div>
                  <p className="text-[#37474F] italic mb-6 leading-relaxed text-sm md:text-base" data-id="element-104">
                    "{test.q}"
                  </p>
                </div>
                <div className="flex items-center gap-4" data-id="element-105">
                  <div className="w-10 h-10 bg-[#1A237E] rounded-full flex items-center justify-center font-bold text-white shrink-0" data-id="element-106">
                    {test.i}
                  </div>
                  <div data-id="element-107">
                    <p className="font-bold text-[#1A237E] text-sm md:text-base" data-id="element-108">
                      {test.n}
                    </p>
                    <p className="text-[10px] md:text-xs text-[#37474F]" data-id="element-109">
                      {test.l}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* WhatsApp Testimonial Screenshots Carousel */}

      {/* Problem Section */}
      <section className="py-4 md:py-16 bg-[#ECEFF1]" data-id="element-110">
        <div className="container mx-auto px-4" data-id="element-111">
          <SectionTitle subtitle="Llegó un mensaje amenazante al grupo de WhatsApp del curso. O alguien difundió una imagen de una alumna. Y en ese momento no hay tiempo para improvisar." data-id="element-112">
            <span className="text-[#1A237E]" data-id="element-113">
              ¿Cuántas situaciones más vas a enfrentar sin saber exactamente qué
              hacer?
            </span>
          </SectionTitle>

          <div className="max-w-3xl mx-auto text-center mb-6 md:mb-12" data-id="element-114">
            <p className="text-lg text-[#37474F] leading-snug mb-3 md:mb-4" data-id="element-115">
              O un padre furioso llega a la dirección exigiendo respuestas. O
              descubrís que un alumno estuvo en contacto con un adulto
              desconocido por Instagram. No hay tiempo para buscar en Google. No
              hay tiempo para equivocarse.
            </p>
            <p className="text-lg text-[#37474F] leading-snug mb-3 md:mb-4" data-id="element-116">
              Nadie te preparó para ese silencio en la sala de profesores cuando
              algo grave pasa y todos te miran esperando que sepas qué hacer.
            </p>
            <p className="text-xl font-bold text-[#E65100]" data-id="element-117">
              No es falta de vocación. Es falta de herramientas concretas.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-2 md:gap-3 max-w-4xl mx-auto" data-id="element-118">
            {['Sin saber qué constituye un delito digital en Argentina', 'Sin un protocolo claro para las primeras horas', 'Sin materiales listos para trabajar con alumnos', 'Sin saber cómo hablarle a las familias sin generar pánico', 'Con miedo a decir algo incorrecto legalmente', 'Sin recursos para que los alumnos reflexionen', 'Sabiendo que algo puede pasar y sin estar preparado/a'].map((item, i) => <div key={i} className="bg-white p-3 md:p-4 rounded-lg flex gap-3 items-start" data-id="element-119">
                <XCircle className="text-[#C62828] shrink-0 mt-1" size={20} data-id="element-120" />
                <p className="text-[#37474F] font-medium leading-snug" data-id="element-121">
                  {item}
                </p>
              </div>)}
          </div>

          <div className="mt-6 md:mt-10 max-w-3xl mx-auto bg-[#FFF8E1] border-l-8 border-[#E65100] p-5 md:p-6 rounded-r-2xl shadow-sm text-center" data-id="element-122">
            <p className="text-xl md:text-2xl font-bold text-[#1A237E] italic leading-tight" data-id="element-123">
              ¿Y si esta fuera la última vez que enfrentás una situación así
              completamente sin herramientas?
            </p>
          </div>
        </div>
      </section>

      {/* Product Hero */}
      <section className="py-4 md:py-16 bg-[#1A237E] text-white" data-id="element-124">
        <div className="container mx-auto px-4 text-center" data-id="element-125">
          <div className="inline-block bg-[#E65100] text-white px-6 py-2 rounded-full font-bold text-sm uppercase tracking-widest mb-4 md:mb-6" data-id="element-126">
            SOLUCIÓN INTEGRAL
          </div>
          <h2 className="text-3xl md:text-6xl font-bold mb-2 md:mb-3 text-white leading-tight" data-id="element-127">
            🚨 CÓDIGO EMERGENCIA ESCOLAR™ PACK COMPLETO
          </h2>
          <p className="text-lg md:text-2xl text-white/70 mb-6 md:mb-10 max-w-3xl mx-auto leading-snug" data-id="element-128">
            4 Módulos + 3 Bonos · 270+ páginas · Todo lo que necesitás para
            prevenir, actuar y acompañar.
          </p>

          <div className="max-w-[1178px] mx-auto mb-6 md:mb-10 relative" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/rzfibkpJEqjQkydDx9baQw/codigo-emergencia-escolar-optimized.webp" alt="Pack Completo Mockup" className="w-full h-auto rounded-3xl shadow-2xl border-2 border-white/10" loading="lazy" data-id="element-130" />
          </div>

          <div className="max-w-3xl mx-auto bg-[#283593] border-l-8 border-[#E65100] p-4 md:p-5 rounded-r-xl text-left" data-id="element-131">
            <p className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2" data-id="element-132">
              Desarrollado por especialistas en derecho y pedagogía.
            </p>
            <p className="text-white/80 leading-snug" data-id="element-133">
              100% adaptado a la realidad legal y educativa argentina.
            </p>
          </div>
        </div>
      </section>

      {/* The 4 Modules */}
      <section className="py-4 md:py-16 bg-white" data-id="element-134">
        <div className="container mx-auto px-4" data-id="element-135">
          <SectionTitle subtitle="Cada módulo incluye protocolos, dinámicas y materiales listos para usar." data-id="element-136">
            <span className="text-[#1A237E]" data-id="element-137">📚 4 MÓDULOS COMPLETOS</span>
          </SectionTitle>

          <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-138">
            {[{
            t: 'MÓDULO 1 — MARCO LEGAL',
            bg: 'bg-[#1A237E]',
            d: 'Lo que la ley dice en lenguaje que cualquier docente puede entender y usar.',
            f: ['Artículos del Código Penal explicados', 'Qué es delito y qué no', 'Responsabilidad del menor en Argentina', 'Ley de Delitos Informáticos 26.388', 'Protocolo de preservación de evidencia']
          }, {
            t: 'MÓDULO 2 — PROTOCOLO DE CRISIS',
            bg: 'bg-[#0D47A1]',
            d: 'Qué hacer en los primeros 60 minutos ante una amenaza. Paso a paso institucional.',
            f: ['Árbol de decisión ante amenaza', 'Cadena de comunicación oficial', 'Cómo preservar evidencia digital', 'Cuándo y cómo llamar a la fiscalía', 'Formularios y registros oficiales']
          }, {
            t: 'MÓDULO 3 — EL TALLER PARTICIPATIVO',
            bg: 'bg-[#283593]',
            d: '9 dinámicas activas listas para usar con alumnos de secundaria hoy mismo.',
            f: ['Actividades disparadoras de reflexión', 'Análisis de casos ficticios realistas', 'Rol del testigo digital', 'Acuerdo de convivencia digital', 'Recursos imprimibles para el aula']
          }, {
            t: 'MÓDULO 4 — ALIANZA ESCUELA-FAMILIA',
            bg: 'bg-[#1A237E]',
            d: 'La guía completa para la reunión de padres. Todo listo para facilitar en 90 minutos.',
            f: ['Agenda de reunión lista para usar', 'Información legal adaptada a familias', 'Dinámicas participativas para padres', 'Acuerdo familiar de uso digital', 'Kit de materiales para llevar a casa']
          }].map((tomo, i) => <div key={i} className={`p-8 rounded-2xl ${tomo.bg} shadow-xl hover:scale-[1.02] transition-all`} data-id="element-139">
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-140">{tomo.t}</h3>
                <p className="text-[#E65100] font-bold mb-4 text-sm uppercase tracking-wider" data-id="element-141">
                  Contenido Exclusivo
                </p>
                <p className="text-white/80 mb-6 text-sm leading-relaxed" data-id="element-142">
                  {tomo.d}
                </p>
                <ul className="space-y-3" data-id="element-143">
                  {tomo.f.map((feature, j) => <li key={j} className="flex items-center gap-3 text-sm text-white" data-id="element-144">
                      <CheckCircle2 size={16} className="text-white shrink-0" data-id="element-145" />{' '}
                      {feature}
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-4 md:py-16 bg-[#ECEFF1]" data-id="element-146">
        <div className="container mx-auto px-4" data-id="element-147">
          <SectionTitle subtitle="Valor total bonos: $18.000 → GRATIS con tu pack" data-id="element-148">
            <span className="text-[#1A237E]" data-id="element-149">🎁 3 BONOS ESTRATÉGICOS</span>
          </SectionTitle>

          <div className="grid md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-150">
            {[{
            n: '01',
            t: 'KIT EXPRESS',
            d: '15 actividades breves y listas para usar para abrir conversaciones sobre amenazas y bullying.',
            v: '$6.000'
          }, {
            n: '02',
            t: 'GUÍA DE FRASES',
            d: 'Las palabras exactas para hablar con estudiantes y familias sobre situaciones difíciles.',
            v: '$6.000'
          }, {
            n: '03',
            t: 'CUADERNILLO',
            d: 'Un workbook ilustrado para que alumnos y familias transformen la información en acción.',
            v: '$6.000'
          }].map((bono, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border-t-8 border-[#E65100] relative overflow-hidden" data-id="element-151">
                <div className="absolute top-0 right-0 bg-[#2E7D32] text-white text-[10px] font-bold px-4 py-1 rounded-bl-lg uppercase" data-id="element-152">
                  Gratis
                </div>
                <span className="text-[#1A237E] font-bold text-sm mb-2 block" data-id="element-153">
                  BONO {bono.n}
                </span>
                <h4 className="text-xl font-bold mb-3 text-[#1A237E]" data-id="element-154">
                  {bono.t}
                </h4>
                <p className="text-[#37474F] text-sm mb-6 leading-relaxed" data-id="element-155">
                  {bono.d}
                </p>
                <p className="text-sm line-through text-[#9E9E9E]" data-id="element-156">{bono.v}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-4 md:py-16 bg-[#1A237E] text-white" id="pricing" data-id="element-157">
        <div className="container mx-auto px-4" data-id="element-158">
          <div className="text-center mb-4 md:mb-10" data-id="element-159">
            <h2 className="text-3xl md:text-5xl font-bold mb-2 md:mb-3 text-white" data-id="element-160">
              Elegí cómo querés acceder al material
            </h2>
            <p className="text-base md:text-xl text-slate-200 max-w-2xl mx-auto font-sans px-4 leading-snug" data-id="element-161">
              Podés llevar el sistema principal o sumar el refuerzo
              institucional para situaciones críticas.
            </p>
          </div>

          <div className="grid md:grid-cols-1 gap-4 md:gap-6 max-w-xl mx-auto items-stretch" data-id="element-162">
            {/* OPCIÓN 1: BÁSICA */}
            <div className="bg-[#0D1B2A]/50 rounded-2xl p-5 md:p-8 text-white shadow-xl flex flex-col border border-white/10 relative" data-id="element-163">
              <div className="mb-4" data-id="element-164">
                <h3 className="text-lg md:text-xl font-bold text-white leading-tight mb-1" data-id="element-165">
                  Código Emergencia Escolar
                </h3>
                <p className="text-3xl md:text-4xl font-bold text-white/90" data-id="element-166">
                  $19.990{' '}
                  <span className="text-xs md:text-sm font-medium opacity-60" data-id="element-167">
                    ARS
                  </span>
                </p>
              </div>

              <p className="text-white/70 text-xs md:text-sm mb-6 flex-grow" data-id="element-168">
                Accedé al material principal para prevención, abordaje y trabajo
                institucional frente a situaciones de bullying, amenazas y
                violencia escolar.
              </p>

              <PaymentTrustBlock dark data-id="element-169" />

              <CTAButton href="https://codigo-emeregencia-escolar-secundaria.impultienda.ar/checkout" className="w-full text-white text-sm md:text-base !py-3 md:!py-4" data-id="element-170">
                → ACCEDER AHORA
              </CTAButton>

              <PurchaseSupportBadges dark data-id="element-171" />
            </div>
          </div>

          <div className="mt-10 text-center" data-id="element-172">
            <p className="text-white/80 text-sm md:text-base font-medium mb-6" data-id="element-173">
              Acceso inmediato. Material digital listo para usar en la
              institución.
            </p>

            <div className="mt-8 bg-[#C62828] text-white p-2 md:p-3 rounded-lg inline-block font-bold text-[10px] md:text-base" data-id="element-174">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-2 md:py-16 bg-white" data-id="element-175">
        <div className="container mx-auto px-4" data-id="element-176">
          <SectionTitle subtitle="La próxima situación difícil puede ser diferente." data-id="element-177">
            <span className="text-[#1A237E]" data-id="element-178">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </span>
          </SectionTitle>

          {/* Mobile View */}
          <div className="block md:hidden space-y-2 max-w-sm mx-auto" data-id="element-179">
            {[{
            s: 'Amenaza en WhatsApp',
            no: 'Parálisis',
            yes: 'Protocolo listo'
          }, {
            s: 'Reunión de padres',
            no: 'Sin palabras',
            yes: 'Agenda y guion'
          }, {
            s: 'Alumno cuenta algo',
            no: 'No saber qué decir',
            yes: 'Frases exactas'
          }, {
            s: 'Taller bullying',
            no: 'Improvisar',
            yes: '9 dinámicas'
          }, {
            s: '¿Qué es delito?',
            no: 'Miedo legal',
            yes: 'Marco explicado'
          }].map((row, i) => <div key={i} className="border border-slate-100 rounded-lg overflow-hidden shadow-sm" data-id="element-180">
                <div className="bg-[#F5F5F5] px-3 py-1 text-[10px] font-bold text-[#1A237E] uppercase" data-id="element-181">
                  {row.s}
                </div>
                <div className="grid grid-cols-2 text-[10px]" data-id="element-182">
                  <div className="bg-[#FFEBEE] p-2 text-[#C62828] flex items-center gap-1 italic border-r border-white" data-id="element-183">
                    <XCircle size={12} className="shrink-0" data-id="element-184" /> {row.no}
                  </div>
                  <div className="bg-[#E8F5E9] p-2 text-[#2E7D32] font-bold flex items-center gap-1" data-id="element-185">
                    <CheckCircle2 size={12} className="shrink-0" data-id="element-186" /> {row.yes}
                  </div>
                </div>
              </div>)}
            <div className="bg-[#1A237E] text-white p-3 text-center rounded-lg mt-4" data-id="element-187">
              <p className="text-xs font-bold" data-id="element-188">
                "Tu escuela preparada desde hoy." 🚨
              </p>
            </div>
          </div>

          {/* Desktop View */}
          <div className="hidden md:block max-w-4xl mx-auto overflow-hidden rounded-2xl border border-slate-200 shadow-xl" data-id="element-189">
            <table className="w-full text-left border-collapse" data-id="element-190">
              <thead data-id="element-191">
                <tr className="bg-[#1A237E] text-white" data-id="element-192">
                  <th className="p-4 md:p-6 font-bold" data-id="element-193">SITUACIÓN</th>
                  <th className="p-4 md:p-6 font-bold" data-id="element-194">❌ SIN EL PACK</th>
                  <th className="p-4 md:p-6 font-bold" data-id="element-195">✅ CON EL PACK</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-196">
                {[{
                s: 'Amenaza en WhatsApp',
                no: 'Parálisis e improvisación',
                yes: 'Módulo 2: protocolo listo en 60 min'
              }, {
                s: 'Reunión de padres urgente',
                no: 'Sin materiales ni palabras',
                yes: 'Módulo 4: agenda y guion completo'
              }, {
                s: 'Alumno que cuenta algo grave',
                no: 'No saber qué decir ni hacer',
                yes: 'Bono 2: frases exactas para ese momento'
              }, {
                s: 'Taller con alumnos sobre bullying',
                no: 'Improvisar sin recursos',
                yes: 'Módulo 3: 9 dinámicas listas'
              }, {
                s: '¿Qué es delito y qué no?',
                no: 'Miedo a decir algo incorrecto',
                yes: 'Módulo 1: marco legal explicado'
              }].map((row, i) => <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'} hover:bg-slate-50 transition-colors`} data-id="element-197">
                    <td className="p-4 md:p-6 text-sm font-bold text-[#1A237E] bg-[#F5F5F5]" data-id="element-198">
                      {row.s}
                    </td>
                    <td className="p-4 md:p-6 text-sm text-[#C62828] bg-[#FFEBEE] italic flex items-center gap-2" data-id="element-199">
                      <XCircle size={16} className="shrink-0" data-id="element-200" /> {row.no}
                    </td>
                    <td className="p-4 md:p-6 text-sm font-bold text-[#2E7D32] bg-[#E8F5E9] flex items-center gap-2" data-id="element-201">
                      <CheckCircle2 size={16} className="shrink-0" data-id="element-202" /> {row.yes}
                    </td>
                  </tr>)}
              </tbody>
            </table>
            <div className="bg-[#1A237E] text-white p-8 text-center border-t-4 border-[#E65100]" data-id="element-203">
              <p className="text-xl font-bold" data-id="element-204">
                "Tu escuela puede estar preparada desde hoy." 🚨
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials 2 */}
      <section className="py-4 md:py-16 bg-[#ECEFF1]" data-id="element-205">
        <div className="container mx-auto px-4" data-id="element-206">
          <SectionTitle subtitle="Más profesionales que ya lo usan" data-id="element-207">
            <span className="text-[#1A237E]" data-id="element-208">❤️ TESTIMONIOS</span>
          </SectionTitle>

          <div className="grid md:grid-cols-2 gap-3 md:gap-6 max-w-5xl mx-auto" data-id="element-209">
            {[{
            n: 'Daniela M.',
            l: 'Mendoza · Profesora de ESI',
            q: 'El Módulo 3 lo usé la semana siguiente de comprarlo. Los alumnos estuvieron enganchados toda la hora.',
            i: 'DM'
          }, {
            n: 'Roberto P.',
            l: 'Buenos Aires · Director de primaria',
            q: 'El Módulo 1 me dio la seguridad legal que necesitaba para hablar con los padres sin tener miedo de decir algo mal.',
            i: 'RP'
          }, {
            n: 'Analía S.',
            l: 'Santa Fe · Orientadora escolar',
            q: 'El Bono 2 lo imprimí y lo tengo en el escritorio. Las frases exactas para cuando un alumno te cuenta algo difícil.',
            i: 'AS'
          }, {
            n: 'Claudia M.',
            l: 'La Plata · Preceptora de secundaria',
            q: 'El Módulo 4 lo usé para la reunión de padres del trimestre. Se fueron con materiales y compromisos.',
            i: 'CM'
          }].map((test, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border-l-8 border-[#1A237E] flex gap-6 items-start" data-id="element-210">
                <div className="w-12 h-12 bg-[#E65100] rounded-full shrink-0 flex items-center justify-center font-bold text-white text-lg" data-id="element-211">
                  {test.i}
                </div>
                <div data-id="element-212">
                  <div className="flex gap-1 mb-2 text-yellow-500" data-id="element-213">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-214" />)}
                  </div>
                  <p className="text-[#37474F] italic mb-4" data-id="element-215">"{test.q}"</p>
                  <p className="font-bold text-[#1A237E] text-sm" data-id="element-216">{test.n}</p>
                  <p className="text-xs text-[#37474F]" data-id="element-217">{test.l}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-4 md:py-16 bg-[#E8F5E9]" data-id="element-218">
        <div className="container mx-auto px-4 text-center" data-id="element-219">
          <div className="max-w-3xl mx-auto bg-white p-5 md:p-10 rounded-3xl border-2 border-[#2E7D32] shadow-sm" data-id="element-220">
            <ShieldCheck size={64} className="text-[#2E7D32] mx-auto mb-3 md:mb-5" data-id="element-221" />
            <h2 className="text-2xl md:text-3xl font-bold mb-2 md:mb-3 text-[#2E7D32] leading-tight" data-id="element-222">
              GARANTÍA 7 DÍAS SIN PREGUNTAS
            </h2>
            <p className="text-base md:text-lg text-[#37474F] mb-4 md:mb-6 leading-snug" data-id="element-223">
              Si abrís el pack y no es lo que esperabas: <br data-id="element-224" />
              <span className="text-2xl md:text-3xl font-bold text-[#2E7D32] block mt-1 md:mt-3" data-id="element-225">
                DEVOLUCIÓN DEL 100%
              </span>
              <span className="text-sm text-[#37474F] mt-1 md:mt-2 block" data-id="element-226">
                sin formularios ni vueltas.
              </span>
            </p>
            <p className="text-[10px] md:text-xs text-[#37474F] uppercase tracking-widest font-bold" data-id="element-227">
              Tasa de devoluciones: menos del 1%
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-4 md:py-16 bg-white" id="faq" data-id="element-228">
        <div className="container mx-auto px-4" data-id="element-229">
          <SectionTitle subtitle="Despejá tus dudas y empezá hoy mismo." data-id="element-230">
            <span className="text-[#1A237E]" data-id="element-231">❓ LO QUE MÁS NOS PREGUNTAN</span>
          </SectionTitle>
          <div className="max-w-3xl mx-auto space-y-2 md:space-y-3" data-id="element-232">
            {[{
            q: '¿Para quién es este pack?',
            a: 'Para docentes, preceptores, orientadores, directivos, profesionales que dan charlas y familias que quieren herramientas concretas sobre seguridad digital escolar en Argentina.'
          }, {
            q: '¿Cómo recibo el material?',
            a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo en tu dispositivo.'
          }, {
            q: '¿Qué lo diferencia de otros materiales?',
            a: 'Está 100% adaptado al contexto legal argentino, con leyes vigentes, lenguaje docente y situaciones reales de escuelas argentinas. No es teoría: son herramientas listas para usar.'
          }, {
            q: '¿Tiene garantía real?',
            a: 'Sí. 7 días sin preguntas. Si abrís el pack y no es lo que esperabas te devolvemos el 100% sin formularios ni vueltas.'
          }].map((faq, i) => <details key={i} className="group bg-[#E8EAF6] rounded-xl overflow-hidden" data-id="element-233">
                <summary className="flex items-center justify-between p-6 cursor-pointer font-bold text-[#1A237E] list-none" data-id="element-234">
                  {faq.q}
                  <ChevronDown size={20} className="text-[#E65100] group-open:rotate-180 transition-transform" data-id="element-235" />
                </summary>
                <div className="px-6 pb-6 bg-white text-[#37474F] leading-relaxed text-sm border-l-8 border-[#E65100]" data-id="element-236">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-4 md:py-16 bg-[#1A237E] text-white text-center" data-id="element-237">
        <div className="container mx-auto px-4" data-id="element-238">
          <SectionTitle light subtitle="Tu escuela puede estar preparada desde hoy. 🚨" data-id="element-239">
            Elegí tu nivel de protección
          </SectionTitle>

          <div className="flex justify-center mb-6 md:mb-10" data-id="element-240">
            <div className="bg-[#C62828] p-3 md:p-4 rounded-xl" data-id="element-241">
              <CountdownTimer data-id="element-242" />
            </div>
          </div>

          <div className="grid md:grid-cols-1 gap-4 md:gap-6 max-w-xl mx-auto mb-6 md:mb-10 items-stretch text-left" data-id="element-243">
            {/* Final CTA - Option 1 */}
            <div className="bg-[#0D1B2A] rounded-2xl p-5 md:p-10 text-white shadow-2xl flex flex-col border-2 border-white/10 relative" data-id="element-244">
              <h3 className="text-xl font-bold mb-1 md:mb-2" data-id="element-245">
                Código Emergencia Escolar
              </h3>
              <p className="text-[#9E9E9E] line-through text-sm" data-id="element-246">$48.000</p>
              <p className="text-3xl md:text-4xl font-bold text-white/90 mb-4 md:mb-6" data-id="element-247">
                $19.990{' '}
                <span className="text-xs font-medium opacity-60" data-id="element-248">ARS</span>
              </p>
              <div className="flex-grow mb-6 md:mb-8" data-id="element-249">
                <p className="text-white/70 text-sm leading-normal" data-id="element-250">
                  Protocolo principal para prevención y abordaje institucional.
                </p>
              </div>

              <PaymentTrustBlock dark data-id="element-251" />

              <CTAButton href="https://codigo-emeregencia-escolar-secundaria.impultienda.ar/checkout" className="w-full text-white text-lg py-4" data-id="element-252">
                → ACCEDER AHORA
              </CTAButton>

              <PurchaseSupportBadges dark data-id="element-253" />
            </div>
          </div>

          <div className="max-w-2xl mx-auto mb-8 md:mb-12" data-id="element-254">
            <p className="text-white/80 text-sm md:text-base font-medium mb-6 md:mb-8 leading-normal" data-id="element-255">
              Acceso inmediato. Material digital listo para usar en la
              institución.
            </p>

            <div className="mt-6 md:mt-8 bg-[#C62828] text-white p-2 md:p-3 rounded-lg inline-block font-bold text-[10px] md:text-base" data-id="element-256">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-8" data-id="element-257">
            <div className="flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-[#1A237E] font-bold text-xs uppercase tracking-widest" data-id="element-258">
              <ShieldCheck size={16} className="text-[#2E7D32]" data-id="element-259" /> Pago 100%
              Seguro
            </div>
            <div className="flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-[#1A237E] font-bold text-xs uppercase tracking-widest" data-id="element-260">
              <CheckCircle2 size={16} className="text-[#2E7D32]" data-id="element-261" /> Garantía de
              Satisfacción
            </div>
            <div className="flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-[#1A237E] font-bold text-xs uppercase tracking-widest" data-id="element-262">
              <Zap size={16} className="text-[#2E7D32]" data-id="element-263" /> Acceso Instantáneo
            </div>
          </div>

          <div className="mt-12 bg-[#C62828] text-white p-3 rounded-lg inline-block font-bold" data-id="element-264">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-6 md:py-12 bg-[#0D1B2A] text-white/60 border-t border-white/5" data-id="element-265">
        <div className="container mx-auto px-4 text-center" data-id="element-266">
          <p className="font-bold text-white text-xl md:text-2xl mb-2 md:mb-3 font-display" data-id="element-267">
            🚨 CÓDIGO EMERGENCIA ESCOLAR™
          </p>
          <p className="text-sm mb-4 md:mb-6 max-w-2xl mx-auto leading-snug text-white/70" data-id="element-268">
            El pack de materiales pedagógicos N°1 para docentes, directivos y
            familias que necesitan herramientas concretas ante amenazas,
            bullying, grooming y violencia digital en Argentina.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-3 md:gap-10 mb-6 md:mb-10 text-sm" data-id="element-269">
            <a href="mailto:contacto@codigoemergenciaescolar.com.ar" className="text-[#E65100] hover:text-white transition-colors flex items-center justify-center gap-2" data-id="element-270">
              <MessageSquare size={16} data-id="element-271" />{' '}
              contacto@codigoemergenciaescolar.com.ar
            </a>
            <div className="flex items-center justify-center gap-2 text-[#E65100]" data-id="element-272">
              <Star size={16} data-id="element-273" /> @codigoemergenciaescolar
            </div>
          </div>
          <div className="w-full h-px bg-white/5 mb-6 md:mb-8" data-id="element-274"></div>
          <p className="text-xs text-[#B0BEC5] leading-normal" data-id="element-275">
            © Código Emergencia Escolar™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-white mt-3 md:mt-4 flex items-center justify-center gap-2 font-bold" data-id="element-276">
            "Tu escuela puede estar preparada desde hoy."{' '}
            <span className="text-[#E65100]" data-id="element-277">🚨</span>
          </p>
        </div>
      </footer>
    </div>;
}